/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */

import React, { useCallback, useEffect } from 'react';
import { Center, Spinner } from 'chakra-v3';
import { Text } from '../components/Text';
import { useNavigate } from 'react-router-dom';

/**
 * Minimal page that triggers logout logic and redirects users home.
 */
const Logout: React.FC = () => {
  const navigate = useNavigate();

  const logout = useCallback(async () => {
    localStorage.removeItem('worker_id');
    await navigate('/');
  }, [navigate]);

  useEffect(() => {
    logout().catch((err) => {
      console.error('Error during logout:', err);
    });
  }, [logout]);

  return (
    <Center w="100%" h="100vh" flexDirection="column" gap={4} bg="bg.primary">
      <Spinner color="text.primary" size="xl" />
      <Text size="md" color="text.primary">
        Signing you out...
      </Text>
    </Center>
  );
};

export default Logout;
